var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/base', 'model/country'], function($, core, BaseCollection, CountryModel) {
  var CountryCollection;
  return CountryCollection = (function(_super) {

    __extends(CountryCollection, _super);

    function CountryCollection() {
      CountryCollection.__super__.constructor.apply(this, arguments);
    }

    CountryCollection.prototype.path = core.getConfig().apiPrefix + 'country.json';

    CountryCollection.prototype.model = CountryModel;

    return CountryCollection;

  })(BaseCollection);
});
